import { render, staticRenderFns } from "./manage-sections-modal.vue?vue&type=template&id=6f6fbcf1"
import script from "./manage-sections-modal.vue?vue&type=script&lang=js"
export * from "./manage-sections-modal.vue?vue&type=script&lang=js"
import style0 from "./manage-sections-modal.vue?vue&type=style&index=0&id=6f6fbcf1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports